import { TrackedEntity, TrackedHistoricalEntity } from './state/entity-panel-manager';

export const getEntityPanelSortComparator = (a: TrackedEntity, b: TrackedEntity) => {
    if (
        a.metadata?.lastUpdatedDateUtc === undefined &&
        b.metadata?.lastUpdatedDateUtc === undefined
    ) {
        return 0;
    }
    if (a.metadata?.lastUpdatedDateUtc === undefined) {
        return -1;
    }
    if (b.metadata?.lastUpdatedDateUtc === undefined) {
        return 1;
    }
    if (a.metadata?.lastUpdatedDateUtc > b.metadata.lastUpdatedDateUtc) {
        return -1;
    }
    if (a.metadata?.lastUpdatedDateUtc < b.metadata.lastUpdatedDateUtc) {
        return 1;
    }
    return 0;
};

export const getHistoricalPanelSortComparator = (
    a: TrackedHistoricalEntity,
    b: TrackedHistoricalEntity
) => {
    if (!a.lastFocused) return 1;
    if (!b.lastFocused) return -1;
    if (a.lastFocused > b.lastFocused) return -1;
    return 1;
};
